export const options = {
    discountEnabled: Boolean(parseInt(process.env.DISCOUNT_ENABLED || '0'))
}
